import { render, staticRenderFns } from "./DocumentListPage.vue?vue&type=template&id=e0c5ff2e&"
import script from "./DocumentListPage.vue?vue&type=script&lang=ts&"
export * from "./DocumentListPage.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentListPage.vue?vue&type=style&index=0&id=e0c5ff2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports